import { useEffect } from "react";
import { trackPageView } from "@/lib/analytics";

const ORIGIN = "https://poly-grid.com";

function setAttr(selector, attr, value) {
  const el = document.head.querySelector(selector);
  if (el) el.setAttribute(attr, value);
}

export function useDocumentMeta({ title, description, path }) {
  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      setAttr('meta[name="description"]', "content", description);
      setAttr('meta[property="og:description"]', "content", description);
      setAttr('meta[name="twitter:description"]', "content", description);
    }
    if (title) {
      setAttr('meta[property="og:title"]', "content", title);
      setAttr('meta[name="twitter:title"]', "content", title);
    }
    if (path) {
      const url = `${ORIGIN}${path}`;
      setAttr('link[rel="canonical"]', "href", url);
      setAttr('meta[property="og:url"]', "content", url);
      setAttr('meta[name="twitter:url"]', "content", url);
    }
    if (path && title) trackPageView({ path, title });
  }, [title, description, path]);
}
